export default "__VITE_ASSET__f636656b__"